import { Component } from "@theme/component";
import { debounce } from "@theme/utilities";
class SearchPageInputComponent extends Component {
  requiredRefs = ["searchPageInput"];
  /**
   * Handles the keydown event on the search input and resets the search when
   * empty and Escape is pressed.
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  handleKeyDown = debounce((event) => {
    const value = this.refs.searchPageInput.value.trim();
    if (event.key === "Escape" && value === "") {
      this.#submitEmptySearch();
    }
  }, 100);
  #submitEmptySearch() {
    const searchInput = this.refs.searchPageInput;
    searchInput.focus();
    searchInput.value = "";
    if (this.#isEmptyState()) return;
    searchInput.form?.submit();
  }
  #isEmptyState = () => {
    const url = new URL(window.location.href);
    const queryParam = url.searchParams.get("q") ?? "";
    return queryParam.trim() === "";
  };
}
if (!customElements.get("search-page-input-component")) {
  customElements.define("search-page-input-component", SearchPageInputComponent);
}
